import { createContext, useContext, useState } from "react";
import { useEffect, useRef } from "react";
import { sessionId } from "./utils";
import { ApiService } from "./apiservices";
const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(0);
    const [rzrpay, setRzrpay] = useState("");
    const didMountRef = useRef(true);
    useEffect(() => {
        if (didMountRef.current) {
            getCounterData();
            getRzrPay();
        }
        didMountRef.current = false
    });
    
    

    const getCounterData = () => {
        const dataString = {
            session_id: sessionId()
        }
        ApiService.postData("get-cart-total", dataString).then((res) => {
            if (res.status == "success") {
                setCartItems(res.counter);
                
            } 
        }).catch(() => {
        });
    }

    const getRzrPay = () => {
        
        ApiService.fetchData("rzrpay").then((res) => {
            if (res.status == "success") {
                setRzrpay(res.rzrPay.po_merchant_key);
                
            } 
        }).catch(() => {
        });
    }

  // Function to add product to cart
  const addCounterCart = (counter) => {
    setCartItems(cartItems + counter);
  };

  return (
    <CartContext.Provider value={{ cartItems, rzrpay, addCounterCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
